<template>
                  <div class="p-2">
  <div class="card" style="width: 100%;">
  <!--<img class="card-img-top" data-src=".../100px180/" alt="Card image cap"> -->
  <div class="card-body">
    <h4 class="card-title">Solutions</h4>
    <p class="card-text"></p>
                <ul class="list-unstyled p-2 card-text">
                  <li class="p-1">
                    <router-link to="/solutions/overview" >Overview</router-link>
                  </li>
                  <li class="p-1">
                    <router-link to="/solutions/overview/productsline"
                      >Products Line</router-link
                    >
                  </li>
                  <li class="p-1">
                    <router-link to="/solutions/overview/servicesstructure" 
                      >Services Structure</router-link
                    >
                   <!-- <ul class="list-unstyled p-2 " style="font-size:1em;"> 
                      <li><router-link to="/solutions/overview/servicesstructure#dataerasure">- Data Erasure & Destruction</router-link></li>
                    <li><router-link to="/solutions/overview/servicesstructure#assetrecovery">- Asset Recovery & Recycling</router-link></li>
                     <li><router-link to="/solutions/overview/servicesstructure#datacentermove">- Migrations & Data Center Moves</router-link></li>
                    

                    </ul> -->
                  </li>
                </ul>
  </div>
</div>
              </div>
</template>

<script>
export default {
    name :'overviewsidenav',
     mounted: function()
  {
    // From testing, without a brief timeout, it won't work.
    setTimeout(
      () => 
      {this.scrollFix(this.$route.hash) 
    
    }
    , 1);

  },
  methods: {
    scrollFix: function(hashbang)
    {
      location.hash = hashbang ;
    }
  }
}
</script>